"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButtonContainer = exports.StyledButtonsWrapper = exports.StyledContentContainer = exports.StyledTitleContainer = exports.StyledCloseIconContainer = exports.StyledModalWrapper = exports.StyledContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledContainer = styled_components_1.default.div `
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  align-items: center;
  display: flex;
  justify-content: center;
`;
const resolveSize = (size) => {
    let resolvedSize;
    switch (size) {
        case 'Large':
            resolvedSize = '860px';
            break;
        case 'XLarge':
            resolvedSize = '1024px';
            break;
        default:
            // Medium Modal
            resolvedSize = '640px';
            break;
    }
    return resolvedSize;
};
exports.StyledModalWrapper = styled_components_1.default.div `
  width: 100%;
  max-width: ${({ size }) => resolveSize(size)};
  display: block;
  background-color: ${({ theme }) => theme.colors.colours.default.white.value};
  text-align: center;
  padding: ${({ theme }) => theme.sizes.m.value} 0 ${({ theme }) => theme.sizes.l.value};
  position: relative;
  max-height: 80vh;
  @media (max-width: ${({ theme }) => { var _a; return (_a = theme.layout.small['device-max-width']) === null || _a === void 0 ? void 0 : _a.value; }}) {
    max-height: calc(100vh - ${({ theme }) => theme.sizes.s.value});
    padding: ${({ theme }) => theme.sizes['2xs'].value} 0 ${({ theme }) => theme.sizes.s.value};
    width: calc(100% - ${({ theme }) => theme.sizes.s.value});
  }
`;
exports.StyledCloseIconContainer = styled_components_1.default.div `
  cursor: pointer;
  position: absolute;
  top: ${({ theme }) => theme.sizes.m.value};
  right: ${({ theme }) => theme.sizes.m.value};
  @media (max-width: ${({ theme }) => { var _a; return (_a = theme.layout.small['device-max-width']) === null || _a === void 0 ? void 0 : _a.value; }}) {
    top: ${({ theme }) => theme.sizes['2xs'].value};
    right: ${({ theme }) => theme.sizes.s.value};
  }
`;
exports.StyledTitleContainer = styled_components_1.default.div `
  margin: ${({ theme }) => theme.sizes['2xs'].value} ${({ theme }) => theme.sizes['2xl'].value}
    ${({ theme }) => theme.sizes.xs.value};
  display: inherit;
  @media (max-width: ${({ theme }) => { var _a; return (_a = theme.layout.small['device-max-width']) === null || _a === void 0 ? void 0 : _a.value; }}) {
    margin: ${({ theme }) => theme.sizes['2xs'].value} ${({ theme }) => theme.sizes.s.value};
  }
`;
exports.StyledContentContainer = styled_components_1.default.div `
  margin: ${({ theme }) => theme.sizes.xs.value} ${({ theme }) => theme.sizes['2xl'].value} 0;
  @media (max-width: ${({ theme }) => { var _a; return (_a = theme.layout.small['device-max-width']) === null || _a === void 0 ? void 0 : _a.value; }}) {
    margin: ${({ theme }) => theme.sizes['2xs'].value} ${({ theme }) => theme.sizes.s.value} 0;
  }
`;
exports.StyledButtonsWrapper = styled_components_1.default.div `
  margin: ${({ theme }) => theme.sizes['2xl'].value} ${({ theme }) => theme.sizes['2xl'].value} 0;
  display: flex;
  justify-content: center;
  @media (max-width: ${({ theme }) => { var _a; return (_a = theme.layout.small['device-max-width']) === null || _a === void 0 ? void 0 : _a.value; }}) {
    flex-direction: column;
    margin: ${({ theme }) => theme.sizes.l.value} ${({ theme }) => theme.sizes.s.value} 0;
  }
`;
exports.StyledButtonContainer = styled_components_1.default.div `
  max-width: 264px;
  width: 100%;
  @media (max-width: ${({ theme }) => { var _a; return (_a = theme.layout.small['device-max-width']) === null || _a === void 0 ? void 0 : _a.value; }}) {
    flex-direction: column;
    max-width: 100%;
  }
  :first-of-type {
    padding-right: ${({ theme }) => theme.sizes['2xs'].value};
    @media (max-width: ${({ theme }) => { var _a; return (_a = theme.layout.small['device-max-width']) === null || _a === void 0 ? void 0 : _a.value; }}) {
      padding-right: 0px;
    }
  }
  :last-of-type {
    padding-left: ${({ theme }) => theme.sizes['2xs'].value};
    @media (max-width: ${({ theme }) => { var _a; return (_a = theme.layout.small['device-max-width']) === null || _a === void 0 ? void 0 : _a.value; }}) {
      padding-left: 0px;
      margin-top: ${({ theme }) => theme.sizes.s.value};
    }
  }
`;
//# sourceMappingURL=Modal.styled.js.map